var _path, _path2, _path3, _path4, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTipLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 94,
    viewBox: "0 0 124 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 5.48333C0 2.45497 2.45497 0 5.48333 0H104.967V10.9667H5.48334C2.45497 10.9667 0 8.51169 0 5.48333V5.48333Z",
    fill: "#8BD8BD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9999 94C43.9716 94 41.5166 91.545 41.5166 88.5167V46.2167H52.4833V88.5167C52.4833 91.545 50.0283 94 46.9999 94V94Z",
    fill: "#8BD8BD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M104.575 38.3833C109.665 38.3833 114.547 36.3614 118.146 32.7622C121.745 29.1631 123.767 24.2816 123.767 19.1917C123.767 14.1017 121.745 9.22025 118.146 5.62111C114.547 2.02198 109.665 9.9105e-07 104.575 0L104.575 10.9778C106.754 10.9778 108.843 11.8432 110.384 13.3836C111.924 14.924 112.789 17.0132 112.789 19.1917C112.789 21.3701 111.924 23.4593 110.384 24.9997C108.843 26.5401 106.754 27.4055 104.575 27.4055L104.575 38.3833Z",
    fill: "#8BD8BD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M60.7083 27.4167C58.188 27.4167 55.6924 27.9131 53.3639 28.8775C51.0355 29.842 48.9198 31.2557 47.1377 33.0378C45.3556 34.8199 43.942 36.9356 42.9775 39.264C42.013 41.5924 41.5166 44.088 41.5166 46.6083L52.4944 46.6083C52.4944 45.5297 52.7069 44.4616 53.1197 43.465C53.5325 42.4685 54.1375 41.563 54.9002 40.8003C55.6629 40.0375 56.5684 39.4325 57.565 39.0197C58.5615 38.6069 59.6296 38.3945 60.7083 38.3945L60.7083 27.4167Z",
    fill: "#8BD8BD"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 60.3164,
    y: 27.4167,
    width: 44.65,
    height: 10.9667,
    fill: "#8BD8BD"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTipLogo);
export default __webpack_public_path__ + "static/media/tip-logo.d081fe5420863e38fcf9a941ffa85986.svg";
export { ForwardRef as ReactComponent };